export default "__VITE_ASSET__CEWcBYTC__"